var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c('Modal',{attrs:{"title":_vm.modalTitle,"isClosable":_vm.isClosable},on:{"close":_vm.onClose}},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }